import { Button, Row, Col } from "antd"
import { useRouter } from "next/router"
import { useAuth } from "../../../../contexts/auth"

export function PageActions() {

  const auth = useAuth() || {}
  const { user } = auth
  const userAuth = user?.claims?.role === "ADMIN_AUDITOR"
  const router = useRouter()

  const handleClose = () => {
    let role = "admin"

    if (userAuth) {
      router.push("/dashboards/submissions")
      return
    }

    const { route } = router
    if (route.includes("implementer")) {
      role = "implementer"
    }
    router.push(`/${role}/submissions`)
  }

  return (
    <Row justify="end" gutter={10}>
      <Col><Button ghost onClick={handleClose}>Cerrar</Button></Col>
    </Row>
  )
}
